import auth from './utils/auth';
import { logUnknownError } from './utils/logger';

export function loadState(name: string, fromLocalStorage?: boolean) {
  const storage = fromLocalStorage ? localStorage : sessionStorage;

  try {
    return JSON.parse(storage.getItem(`insurance-claim.${name}`) || '{}');
  } catch (error) {
    logUnknownError(error);
    return {};
  }
}

export function saveState(
  name: string,
  value: unknown,
  toLocalStorage?: boolean
) {
  const storage = toLocalStorage ? localStorage : sessionStorage;

  try {
    storage.setItem(`insurance-claim.${name}`, JSON.stringify(value));
  } catch (error) {
    logUnknownError(error);
  }
}

export function clearState(name: string, inLocalStorage?: boolean) {
  const storage = inLocalStorage ? localStorage : sessionStorage;

  try {
    storage.removeItem(`insurance-claim.${name}`);
  } catch (error) {
    logUnknownError(error);
  }
}

export function createPersistor(name: string, useLocalStorage?: boolean) {
  const sessionName = `${auth.idTokenParsed.cm_id}-${name}`;
  const load = () => loadState(sessionName, useLocalStorage);
  const save = (value: unknown) =>
    saveState(sessionName, value, useLocalStorage);
  const clear = () => clearState(sessionName, useLocalStorage);

  return { load, save, clear };
}

export function clearAll(
  { except }: { except: Array<string> } = { except: [] }
) {
  try {
    Object.keys(sessionStorage).forEach(key => {
      if (
        key.startsWith('insurance-claim.') &&
        !except.includes(key.replace('insurance-claim.', ''))
      ) {
        sessionStorage.removeItem(key);
      }
    });
  } catch (error) {
    logUnknownError(error);
  }
}
